import {
  CompanyAttributes,
  DocumentClassAttributes,
  MaterialStockAttributes,
  OrderAttributes,
  OrderDetailAttributes,
  OrderExtraStatusAttributes,
  WarehouseAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { SelectionModel } from "@angular/cdk/collections";
import { CommonModule, DecimalPipe } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule, Sort } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { WarehouseService } from "../../configuration/warehouse/warehouse.service";
import { DocumentClassService } from "../../document/document-class/document-class.service";
import { MasterUserInterface } from "../order-generate/interfaces/master-user.interface";
import { OrdersListService } from "../order-list-components/order-list.service";
import { UpdateOrderService } from "../update-order/update-order.service";

import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import OrderPaymentAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatRadioModule } from "@angular/material/radio";
import { MatTabsModule } from "@angular/material/tabs";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import {
  IPaginationResultFrequencies,
  IRequestResult,
} from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import {
  ExportDialogComponent,
  ExportOptions,
} from "app/layout/export-overlay";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { LogModalComponent } from "app/modules/shared/log-modal/log-modal.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { BusinessPartnerDisplayComponent } from "app/shared/components/business-partner-display/business-partner-display.component";
import { DateHelper } from "app/utils/date.helper";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  lastValueFrom,
  skip,
  Subject,
  Subscription,
  take,
  takeUntil,
} from "rxjs";
import { PaymentMethodsTabComponent } from "../../../../shared/components/payment-methods-tab/payment-methods-tab.component";
import { GroupedPayment } from "../../../../shared/interfaces/payment.interface";
import { CompanyService } from "../../configuration/company/company.service.service";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "../../filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "../../filters/documents-filters/documents-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "../../filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { CreditNoteDialogComponent } from "../../monitor/payment-load-list/credit-note/credit-note.component";
import { OrderPaymentAService } from "../../reports/historic/order-payment/order-payment.service";
import { FormApproRejectComponent } from "../../shared/form-appro-reject/form-appro-reject.component";
import { TypeRejectEnum } from "../../shared/form-appro-reject/type-document.enum";
import { AddOrderDetailComponent } from "../add-order-detail/add-order-detail.component";
import { CancelOrderComponent } from "../cancel-order/cancel-order.component";
import { SALES_ORDERS_LIST_TITLE } from "../order-list-components/exports/sales-orders-list.constants";
import { OrdersCreationService } from "../quotation-generate/quotation-generate.service";
import { SelectOrderDetailComponent } from "../select-order-detail/select-order-detail.component";
import { IUpdateOrder, IUserApprovalResponse } from "../update-order/interfaces/update-order.interface";
import { UpdateOrderComponent } from "../update-order/update-order.component";
import { SalesInvoiceListExport } from "./exports/sales-invoice-list.export";
import { InvoicePdfOptions } from "./Print/invoice-pdf-options.interface";
import { InvoiceService } from "./Print/pdf-generator.service";
import { UnitMeasureDisplayComponent } from "../../../../shared/components/unit-measure-display/unit-measure-display.component";

@Component({
  selector: "app-invoice-list",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    //FormatOtherDateHourPipe,
    MatAutocompleteModule,
    FilterComponent,
    DocumentFlowButtonComponent,
    DecimalFormatPipe,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    MaterialsManagementFiltersComponent,
    PaymentMethodsTabComponent,
    BusinessPartnerDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe,
    UnitMeasureDisplayComponent,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    SalesInvoiceListExport,
  ],
  templateUrl: "./invoice-list.component.html",
  styleUrl: "./invoice-list.component.scss",
  animations: [
    trigger("detailExpand", [
      state("collapsed,void", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class InvoiceListComponent implements OnDestroy {
  isReprintLoading: { [key: string]: boolean } = {};
  getCode = getCode;
  projectName = environment.projectName;

  StatusEnum = StatusEnum;
  OrderStatusERPEnum = OrderStatusERPEnum;
  DocumentTypeEnum = DocumentTypeEnum;
  type = DocumentTypeEnum.FACTURA;

  private isInitialized = false;

  subs: Subscription[] = [];
  ordersToFilter: string[] = [];

  displayedColumns: string[] = [
    "det",
    "check",
    "status",
    "statusERP",
    "type",
    "trip",
    "info",
    // "subRoute",
    // "user",
    // "seller",
    "businessPartner",
    "documentNumber",
    "class",
    //'date',
    "subTotal",
    //'surcharge', 'discount', 'tax',
    "total",
    "creation",
    //'documentStatus',
    "actions",
  ];
  dataSource = new MatTableDataSource<OrderAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  selection = new SelectionModel<any>(true, []);
  selectedOrder: OrderAttributes | null = null;
  selectedOrderPayments: OrderPaymentAttributes[] = [];
  isLoadingPayments: boolean = false;

  //DETAIL 1 Posiciones del pedido
  displayedColumnsDetail1: string[] = [
    "material",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "totalSurcharges",
    "totalDiscounts",
    "totalTaxes",
    "total",
    "actions",
  ];
  dataSourceDetail1 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail1") sortDetail1: MatSort;

  //DETAIL 2 Entrega
  displayedColumnsDetail2: string[] = [
    "material",
    "soldQuantity",
    "confirmedQuantity",
    "deliveredQuantity",
    "relatedDocuments",
  ];
  dataSourceDetail2 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail2") sortDetail2: MatSort;

  //DETAIL 3 Factura
  displayedColumnsDetail3: string[] = [
    "material",
    "soldQuantity",
    "invoicedQuantity",
    "invoicedPrice",
    "invoicedDiscount",
    "invoice",
  ];
  dataSourceDetail3 = new MatTableDataSource<OrderDetailAttributes>([]);
  @ViewChild("sortDetail3") sortDetail3: MatSort;

  companyList: CompanyAttributes[] = [];
  currency: string = "";

  //Filter
  selectedStartDate: Date;
  selectedEndDate: Date;
  dateRange: FormGroup;

  // selectedStatusERP: number = 0;
  // Selección múltiple
  selectedStatusERP: number[] = [];

  // Controlador de búsqueda
  statusFilterCtrl = new FormControl();

  // Estados filtrados
  filteredStatusERP: BehaviorSubject<any[]> = new BehaviorSubject([]);

  // Estados de selección
  isStatusIndeterminate = false;
  isStatusChecked = false;

  private _onDestroy = new Subject<void>();

  // selectedDocumentClass: string = '0';
  selectedDocumentClass: string[] = [];
  filteredDocumentClasses: Subject<DocumentClassAttributes[]> = new Subject();
  documentClassMultiFilterCtrl: FormControl = new FormControl();
  isIndeterminateDocumentClass: boolean = false;
  isCheckedDocumentClass: boolean = false;
  private _onDestroyDocumentClass = new Subject<void>();

  selectedSeller: string = "0";
  selectedWithTravel: string[] = [];

  documentClassesList: DocumentClassAttributes[] = [];
  sellerList: MasterUserInterface[] = [];

  isGlobalSynchronizeAvailable: boolean = false;

  orderStatusErpList = [
    { id: null, name: "Todos" },
    { id: 0, name: "Factura pendiente" },
    { id: 4, name: "Error enviando a ERP" },
    { id: 1, name: "Factura enviado a ERP" },
    { id: 2, name: "Factura recibido por ERP" },
    { id: 3, name: "Factura creada en ERP" },
  ];

  isOrderListTrip = environment.isOrderListTrip;

  @ViewChild("orderDetailUpdateConfirmationDialog")
  orderDetailUpdateConfirmationDialog!: TemplateRef<any>;

  interval;
  timeInterval = 60000 * 15;
  showInterval: boolean = false;

  companies: CompanyAttributes[] = [];
  UMPActive: boolean;

  //popup
  @ViewChild("popupTemplate", { read: TemplateRef })
  popupTemplate!: TemplateRef<any>;
  isPopupVisible = false;
  popupText = null;
  popupStyle: any = {};

  selectedSoldTo: string = "0";
  soldToControl = new FormControl("");
  soldToList: any[] = [];
  soldToFilterSelected: any = null;

  selectedShipTo: string = "0";
  shipToControl = new FormControl("");
  shipToList: any[] = [];

  //BUSCADOR
  searchSubscription: Subscription;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  form: FormGroup;

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private ordersListService: OrdersListService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly ordersCreationService: OrdersCreationService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly documentClassService: DocumentClassService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private salesInvoiceListExport: SalesInvoiceListExport,
    private viewContainerRef: ViewContainerRef,
    private readonly router: Router,
    private activatedRoute: ActivatedRoute,
    private readonly orderPaymentService: OrderPaymentAService,
    private invoiceService: InvoiceService,
    private companyCurrencyPipe: CompanyCurrencyPipe
  ) {
    const today = new Date();
    this.dateRange = this.fb.group({
      start: [today],
      end: [today],
    });
    this.selectedStartDate = today;
    this.selectedEndDate = today;
    // this.selectedStartDate.setHours(0, 0, 0, 0);
    this.selectedEndDate.setHours(23, 59, 59, 999);

    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();

    this.subs.push(
      this.activatedRoute.queryParams.pipe(take(1)).subscribe((params) => {
        if (params["invoiceIds"]) {
          this.ordersToFilter = params["invoiceIds"]
            ? params["invoiceIds"].split(",")
            : [];
        }

        this.getCompanies().then(() => {
          this.fetchDocumentClass();
          this.onFilter();
          this.isInitialized = true;
        });
      })
    );

    this.currency = this.companyCurrencyPipe.transform("code");
  }

  ngAfterViewInit(): void {
    this.documentClassMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroyDocumentClass))
      .subscribe(() => {
        this.filterDocumentClasses();
        this.setToggleAllCheckboxStateDocumentClass();
      });

    this.searchControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((filterValue: string) => {
        if (this.isInitialized) {
          this.pageIndex = 1;
          this.search = filterValue;
          this.getList();
        }
      });

    this.soldToControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((value) => {
        if (!this.isInitialized) return;

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.soldToList = [];
        this.soldToFilterSelected = null;
        this.getListSoldTo(value);
        this.getList();
      });

    this.shipToControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged(),
        takeUntil(this._onDestroy)
      )
      .subscribe((value) => {
        if (!this.isInitialized) return;

        if (
          typeof value === "string" &&
          value.trim().length === 24 &&
          /^[a-f0-9]{24}$/.test(value)
        ) {
          return;
        }

        this.shipToList = [];
        this.getListShipTo(value);
        this.getList();
      });

    this.filteredStatusERP.next(this.orderStatusErpList);
    this.cdr.detectChanges();
    this.statusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterStatusERP();
      });
  }

  private filterDocumentClasses(): void {
    if (!this.documentClassesList) {
      return;
    }
    let search = this.documentClassMultiFilterCtrl.value;
    if (!search) {
      this.filteredDocumentClasses.next(this.documentClassesList);
      return;
    } else {
      search = search.toLowerCase();
    }
    const filtered = this.documentClassesList.filter((docClass) =>
      docClass.name.toLowerCase().includes(search)
    );
    this.filteredDocumentClasses.next(filtered);
  }

  onDocumentClassSelectionChange(selectedValues: string[]): void {
    this.selectedDocumentClass = selectedValues;
  }

  private setToggleAllCheckboxStateDocumentClass(): void {
    const selectedCount = this.selectedDocumentClass.length;
    const totalCount = this.documentClassesList.length;

    this.isCheckedDocumentClass =
      selectedCount > 0 && selectedCount === totalCount;
    this.isIndeterminateDocumentClass =
      selectedCount > 0 && selectedCount < totalCount;
  }

  filterStatusERP(): void {
    const search = this.statusFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.orderStatusErpList.filter((os) =>
      os.name.toLowerCase().includes(search)
    );
    this.filteredStatusERP.next(filtered);
  }

  onStatusSelectionChange(selected: number[]): void {
    this.selectedStatusERP = selected;
    this.updateStatusSelectionState();
  }

  toggleSelectAllStatuses(isChecked: boolean): void {
    this.selectedStatusERP = isChecked
      ? this.orderStatusErpList.map((os) => os.id)
      : [];
    this.updateStatusSelectionState();
  }

  updateStatusSelectionState(): void {
    const total = this.orderStatusErpList.length;
    const selected = this.selectedStatusERP.length;
    this.isStatusChecked = total > 0 && selected === total;
    this.isStatusIndeterminate = selected > 0 && selected < total;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getList();
  }

  openInterval(event) {
    //para el html si se quiere activar o no
    if (!event) {
      this.showInterval = false;
    } else {
      this.showInterval = true;
    }
    this.onFilter();
  }

  onFilter() {
    if (this.showInterval) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.getList();

      this.interval = setInterval(() => {
        this.getList();
      }, this.timeInterval);
    } else {
      this.getList();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300))
      .subscribe((term) => {
        if (this.isInitialized) {
          this.applyFilter(term);
        }
      });
  }

  getList() {
    this.synchronizeDates();
    this.isGlobalSynchronizeAvailable = false;
    this.resetSelection();

    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };

    let value: string | null = null;
    if (
      this.selectedWithTravel.includes("1") &&
      this.selectedWithTravel.includes("2")
    ) {
      value = "0"; // Filtrar por ambos
    } else if (this.selectedWithTravel.includes("1")) {
      value = "1"; // Filtrar solo por empleados
    } else if (this.selectedWithTravel.includes("2")) {
      value = "2"; // Filtrar solo por externos
    }

    const hasOrderIds = this.ordersToFilter && this.ordersToFilter.length > 0;
    const hasSearch = this.search && this.search.trim().length > 0;

    let dataFilter: IFilters = {
      type: this.type,

      startDate:
        !hasOrderIds && this.form.get("start")?.value
          ? DateHelper.getStartOfDay(this.form.get("start").value)
          : null,
      endDate:
        !hasOrderIds && this.form.get("end")?.value
          ? DateHelper.getEndOfDay(this.form.get("end").value)
          : !hasOrderIds && this.form.get("start")?.value
            ? DateHelper.getEndOfDay(this.form.get("start").value)
            : null,

      startTrip:
        !hasOrderIds && this.form.get("startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("startTrip").value)
          : null,
      endTrip:
        !hasOrderIds && this.form.get("endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("endTrip").value)
          : !hasOrderIds && this.form.get("startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("startTrip").value)
            : null,

      end_startTrip:
        !hasOrderIds && this.form.get("end_startTrip")?.value
          ? DateHelper.getStartOfDay(this.form.get("end_startTrip").value)
          : null,
      end_endTrip:
        !hasOrderIds && this.form.get("end_endTrip")?.value
          ? DateHelper.getEndOfDay(this.form.get("end_endTrip").value)
          : !hasOrderIds && this.form.get("end_startTrip")?.value
            ? DateHelper.getEndOfDay(this.form.get("end_startTrip").value)
            : null,

      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value,
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      withTravel: value,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,

      status:
        !hasOrderIds && this.selectedStatuses?.length > 0
          ? this.selectedStatuses
          : null,
      statusERP:
        !hasOrderIds && this.selectedERPStatuses?.length > 0
          ? this.selectedERPStatuses
          : null,
      typeCustomer:
        !hasOrderIds && this.selectedCustomerType?.length > 0
          ? this.selectedCustomerType
          : null,

      ordersToFilter: hasOrderIds && !hasSearch ? this.ordersToFilter : null,
    };

    if (hasOrderIds && !hasSearch) {
      this.ordersToFilter = null;
    }

    this.ordersListService.findAllWithCount(options, dataFilter).subscribe({
      next: (res: IPaginationResultFrequencies<OrderAttributes>) => {
        this.dataSource.data = res?.data?.data ?? [];
        this.totalItems = res?.data?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener información de los pedidos.",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  private getSortField(): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
    };
    return sortFieldMapping[this.sortActive] || "creationDateTime";
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction;
    this.getList();
  }

  changePage(e: PageEvent) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getList();
  }

  isAllSelected() {
    const validRows = this.dataSource.data.filter((row) =>
      this.validateDataToSynchronize(row)
    );

    const numSelected = this.selection.selected.length;
    const numValidRows = validRows.length;
    return numSelected === numValidRows && numValidRows > 0;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          if (this.validateDataToSynchronize(row)) this.selection.select(row);
        });
  }

  resetSelection() {
    this.selection.clear();
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  onCheckboxChange(event, element?): void {
    let auxSelected = this.selection.selected;
    this.isGlobalSynchronizeAvailable =
      auxSelected.length > 0 &&
      auxSelected.filter((os) => !this.validateDataToSynchronize(os)).length ==
        0;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.selectedOrder = order;
    this.dataSourceDetail1.data =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail
        : [];
    this.dataSourceDetail1.sort = this.sortDetail1;
    this.setDeliveredAndInvoicedTables();

    // Load payments for selected invoice
    this.loadOrderPayments(order?.serial);

    // Obtiene compañía para hacer uso de flags
    const companyFound: CompanyAttributes = this.companies.find(
      (c) => c.id == this.selectedOrder.company?.id
    );
    if (companyFound) this.selectedOrder.company = companyFound;

    // Obtiene almacenes y clase de documento
    const orderStatusId = this.selectedOrder.statusId;
    if (
      orderStatusId != 0 &&
      orderStatusId != StatusEnum.ORDER_APPROVED &&
      orderStatusId != StatusEnum.ORDER_REJECTED
    ) {
      await this.getDocumentClass(this.selectedOrder);

      if (
        this.selectedOrder.class["showCurrentStockForMaterials"] == true &&
        !this.selectedOrder["warehousesToUpdate"]
      ) {
        const salesOffice: Partial<SalesOfficeAttributes> = await lastValueFrom(
          this.salesOfficeService.findOne(
            this.selectedOrder.salesOffice._id.toString()
          )
        ).then((res) => res.data);
        if (salesOffice && salesOffice.warehouses) {
          let filter = {
            officeWarehouse: salesOffice.warehouses.map((ware) => ware._id),
            company: [environment.companyId],
          };
          this.selectedOrder["warehousesToUpdate"] = await lastValueFrom(
            this.warehouseService.filterComboBox(filter)
          ).then((res) => res.data);
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
        }
      }
    }
  }

  setDeliveredAndInvoicedTables() {
    let detailAux2 =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail.filter(
            (od) => od.statusId == StatusEnum.ACTIVE && od.soldQuantity > 0
          )
        : [];
    this.dataSourceDetail2.data = detailAux2.map((detail) => ({
      ...detail,
      deliveryDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "DELIVERY") || null,
    }));
    this.dataSourceDetail2.sort = this.sortDetail2;

    let detailAux3 =
      this.selectedOrder.detail && this.selectedOrder.detail.length > 0
        ? this.selectedOrder.detail.filter(
            (od) => od.statusId == StatusEnum.ACTIVE && od.soldQuantity > 0
          )
        : [];
    this.dataSourceDetail3.data = detailAux3.map((detail) => ({
      ...detail,
      invoiceDocument:
        detail.relatedDocuments?.find((doc) => doc.type === "INVOICE") || null,
    }));
    this.dataSourceDetail3.sort = this.sortDetail3;
  }

  sortData(sort: Sort, tab) {
    let dataTable = this.dataSourceDetail1.data.slice();
    if (tab == "tab1") {
      dataTable = this.dataSourceDetail1.data.slice();
    }
    if (tab == "tab2") {
      dataTable = this.dataSourceDetail2.data.slice();
    }
    if (tab == "tab3") {
      dataTable = this.dataSourceDetail3.data.slice();
    }

    dataTable.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "material":
          return this.compare(a.material?.name, b.material?.name, isAsc);
        case "note":
          return this.compare(a.note, b.note, isAsc);
        case "warehouse":
          return this.compare(a.warehouse?.name, b.warehouse?.name, isAsc);
        case "soldQuantity":
          return this.compare(
            Number(a.soldQuantity),
            Number(b.soldQuantity),
            isAsc
          );
        case "unitPrice":
          return this.compare(Number(a.unitPrice), Number(b.unitPrice), isAsc);
        case "subTotal":
          return this.compare(Number(a.subTotal), Number(b.subTotal), isAsc);
        case "subTotalBeforeTaxes":
          return this.compare(
            Number(a.subTotalBeforeTaxes),
            Number(b.subTotalBeforeTaxes),
            isAsc
          );
        case "totalSurcharges":
          return this.compare(
            Number(a.totalSurcharges),
            Number(b.totalSurcharges),
            isAsc
          );
        case "totalDiscounts":
          return this.compare(
            Number(a.totalDiscounts),
            Number(b.totalDiscounts),
            isAsc
          );
        case "totalTaxes":
          return this.compare(
            Number(a.totalTaxes),
            Number(b.totalTaxes),
            isAsc
          );
        case "total":
          return this.compare(Number(a.total), Number(b.total), isAsc);
        default:
          return 0;
      }
    });

    if (tab == "tab1") {
      this.dataSourceDetail1.data = dataTable;
    }
    if (tab == "tab2") {
      this.dataSourceDetail2.data = dataTable;
    }
    if (tab == "tab3") {
      this.dataSourceDetail3.data = dataTable;
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  showPopup(event: MouseEvent, detail: OrderDetailAttributes) {
    if (!detail.note || detail.note.trim() === "") return;

    this.popupText = detail.note || null;
    this.popupStyle = {
      top: `${event.clientY + 10}px`,
      left: `${event.clientX}px`,
    };

    this.isPopupVisible = true;
    this.viewContainerRef.createEmbeddedView(this.popupTemplate);
  }

  hidePopupWithDelay() {
    setTimeout(() => {
      this.isPopupVisible = false;
      this.viewContainerRef.clear();
    }, 500);
  }

  closeDetails(): void {
    this.selectedOrder = null;
    this.selectedOrderPayments = [];
    this.isLoadingPayments = false;
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, "0");
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const seconds = d.getSeconds().toString().padStart(2, "0");
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return "--:--:--";
  }

  formatHour(date: string): string {
    if (date) {
      const d = new Date(date);
      const hours = d.getHours().toString().padStart(2, "0");
      const minutes = d.getMinutes().toString().padStart(2, "0");
      const seconds = d.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
    return "--:--:--";
  }

  onCompanySelectionChange(companyid: string): void {
    /*if (this.currentUpdateWarehouse) {
      this.currentUpdateWarehouse.company = this.companyList.find(
        (price) => price._id.toString() === companyid
      )!;
    }*/
  }

  toggleTravel(travel: string): void {
    // Si el rol ya está seleccionado, lo eliminamos
    if (this.selectedWithTravel.includes(travel)) {
      this.selectedWithTravel = this.selectedWithTravel.filter(
        (r) => r !== travel
      );
    } else {
      // Si no está seleccionado, lo agregamos
      this.selectedWithTravel.push(travel);
    }
  }

  clearFilters(): void {
    /*this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.findAllWithCount();*/
    const today = new Date();
    this.dateRange.reset({ start: today, end: today });
    this.selectedStartDate = null;
    this.selectedEndDate = null;
    this.selectedDocumentClass = [];
    this.selectedStatusERP = [];
    this.selectedWithTravel = [];
    this.selectedSeller = "0";
    this.soldToControl.setValue("");
    this.shipToControl.setValue("");
    this.soldToFilterSelected = null;
  }

  synchronizeDates(): void {
    this.selectedStartDate = this.dateRange.get("start")?.value;
    this.selectedEndDate = this.dateRange.get("end")?.value;
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private fetchDocumentClass(): void {
    let dataToFilter = {
      type: this.type,
    };
    // this.ordersListService.fetchDocumentClasses(dataToFilter).subscribe((res) => {
    //   this.documentClassesList = res.data;
    // })
    this.ordersListService
      .fetchDocumentClasses(dataToFilter)
      .subscribe((res) => {
        this.documentClassesList = res.data;
        this.filteredDocumentClasses.next(this.documentClassesList);
      });
  }

  async getCompanies(): Promise<void> {
    this.companies = [];
    await lastValueFrom(this.companyService.fetchCompanyByEnvIds())
      .then((res) => {
        this.companies = res.data;
        if (res.data.length === 1) {
          this.UMPActive = res.data[0].UMPActive;
        }
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al obtener compañias.",
          "Cerrar",
          { duration: 3000 }
        );
      });
  }

  private getListSeller() {
    this.ordersListService.fetchMasterUsers().subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if (res.status == "success") {
          this.sellerList = res.data;
        }
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sellers",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  getListSoldTo(search?): void {
    let dataToSend = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };
    this.ordersListService.fetchSoldTos(dataToSend).subscribe((res) => {
      this.soldToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  onChangeSoldTo() {
    this.soldToFilterSelected = this.soldToList.find(
      (stl) => stl.id == this.soldToControl.value
    );
    this.shipToControl.setValue("");
    this.getListShipTo();
  }

  getListShipTo(search?): void {
    this.shipToList = [];
    const soldToValue = this.soldToFilterSelected
      ? this.soldToFilterSelected._id
      : null;

    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || "",
    };

    if (soldToValue) {
      dataToSend.soldToMongoId = soldToValue;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) => {
      this.shipToList = res?.data;
      this.cdr.detectChanges();
    });
  }

  synchronizeOrders(order: OrderAttributes) {
    let dataToSendPost = {
      TripIds: [],
      orderIds: [],
      method: "POST",
    };

    let dataToSendPut = {
      TripIds: [],
      orderIds: [],
      method: "PUT",
    };

    if (order) {
      if (order?.externalKeys?.code) {
        dataToSendPut.orderIds.push(order._id.toString());
      } else {
        dataToSendPost.orderIds.push(order._id.toString());
      }
    } else {
      this.selection.selected.forEach((o) => {
        if (o.externalKeys?.code) {
          dataToSendPut.orderIds.push(o._id.toString());
        } else {
          dataToSendPost.orderIds.push(o._id.toString());
        }
      });
    }

    const requests = [];
    if (dataToSendPost.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPost).toPromise()
      );
    }
    if (dataToSendPut.orderIds.length > 0) {
      requests.push(
        this.ordersListService.synchronizeOrders(dataToSendPut).toPromise()
      );
    }

    if (requests.length === 0) {
      this.snackBar.open(
        "No se encontraron registros pendientes de sincronizar con ERP.",
        "Cerrar",
        { duration: 5000 }
      );
    }

    Promise.all(requests)
      .then(() => {
        this.snackBar.open("Registro sincronizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      })
      .catch((err) => {
        this.snackBar.open(
          err.error.message || "Error al sincronizar con el ERP.",
          "Cerrar",
          { duration: 5000 }
        );
      });
  }

  getExtraStatusName(list: OrderExtraStatusAttributes[], type: string) {
    const status = list.find((i) => i.type == type);
    return status?.description || "-";
  }

  onUpdateOrder(order: OrderAttributes): void {
    const dialogRef = this.dialog.open(UpdateOrderComponent, {
      panelClass: "form-modal",
      data: order,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.address = result.data.address;
            order.expeditionCondition = result.data.expeditionCondition;
            order.note = result.data.note;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        this.cdr.detectChanges();
      }
    });
  }

  onCancelOrder(
    order: OrderAttributes,
    orderDetail?: OrderDetailAttributes
  ): void {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      panelClass: "form-modal",
      data: {
        type: orderDetail ? "DETAIL" : "ORDER",
        order: order,
        orderDetail: orderDetail,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          const detailTemp: OrderDetailAttributes[] = result.data.detail.map(
            (d) => {
              const detailFoundInLocal = this.selectedOrder.detail.find(
                (od) => od.position == d.position
              );
              d["stock"] = detailFoundInLocal
                ? detailFoundInLocal["stock"]
                : [];
              d["stockToValidate"] = detailFoundInLocal
                ? detailFoundInLocal["stockToValidate"]
                : undefined;
              return d;
            }
          );
          this.selectedOrder.detail = detailTemp;
          this.dataSourceDetail1.data = this.selectedOrder.detail;
        }
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.reasonForRejection = result.data.reasonForRejection;
            order.statusERP = result.data.statusERP;
            order.statusId = result.data.statusId;
          }
        });
        this.dataSource.data = dataTemp;
        if (orderDetail) this.setDeliveredAndInvoicedTables();
        this.cdr.detectChanges();
      }
    });
  }

  onAddOrderDetail(order: OrderAttributes): void {
    const dialogRef = this.dialog.open(AddOrderDetailComponent, {
      panelClass: "form-modal",
      data: {
        order,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
        const dataTemp = this.dataSource.data.slice();
        dataTemp.forEach((order) => {
          if (String(order._id) == String(result.data._id)) {
            order.subTotal = result.data.subTotal;
            order.totalDiscounts = result.data.totalDiscounts;
            order.totalSurcharges = result.data.totalSurcharges;
            order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
            order.totalTaxes = result.data.totalTaxes;
            order.total = result.data.total;
            order.detail = result.data.detail;
            order.statusERP = result.data.statusERP;
          }
        });
        this.dataSource.data = dataTemp;
        if (
          this.selectedOrder &&
          String(this.selectedOrder._id) == String(order._id)
        ) {
          this.selectedOrder.detail = result.data.detail || [];
          this.dataSourceDetail1.data = this.selectedOrder.detail;
          this.getStock(
            this.selectedOrder,
            this.selectedOrder["warehousesToUpdate"]
          );
          this.setDeliveredAndInvoicedTables();
        }
        this.cdr.detectChanges();
      }
    });
  }

  onChangeWarehouseInOrderDetail(orderDetail: OrderDetailAttributes): void {
    orderDetail["stockToValidate"] = 0;
    if (orderDetail["stock"])
      orderDetail["stockToValidate"] = this.roundToX(
        orderDetail["stock"].find(
          (s: MaterialStockAttributes) =>
            String(s.warehouseId) == String(orderDetail.warehouse._id) &&
            String(s.unitOfMeasureId) ==
              String(orderDetail.soldUnitOfMeasure._id)
        )?.availableStock ?? 0,
        3
      );
    this.cdr.detectChanges();
  }

  onChangeSubTotalInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.soldQuantity < 0) {
      orderDetail.soldQuantity = 0;
      this.snackBar.open("La cantidad no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }

    orderDetail.subTotal = orderDetail.unitPrice * orderDetail.soldQuantity;

    // Calcula descuentos
    orderDetail.totalDiscounts = 0;
    if (orderDetail.discounts && orderDetail.discounts.length > 0) {
      orderDetail.totalDiscounts = orderDetail.discounts.reduce(
        (acc, discount) => {
          switch (discount.type) {
            case "PERCENTAGE":
              return acc + (orderDetail.subTotal * discount.discount) / 100;
            case "AMOUNT":
              return acc + discount.discount;
            default:
              return acc;
          }
        },
        0
      );
    }

    orderDetail.subTotalBeforeTaxes =
      orderDetail.subTotal -
      orderDetail.totalDiscounts +
      orderDetail.totalSurcharges;

    // Calcula impuestos
    orderDetail.totalTaxes = 0;
    if (orderDetail.taxes && orderDetail.taxes.length > 0) {
      orderDetail.totalTaxes = orderDetail.taxes.reduce(
        (acc, tax) =>
          acc + (orderDetail.subTotalBeforeTaxes * tax.percentage) / 100,
        0
      );
    }

    orderDetail.total =
      orderDetail.subTotalBeforeTaxes + orderDetail.totalTaxes;
    this.calculateOrderTotals(order);
  }

  calculateOrderTotals(order: OrderAttributes): void {
    order.subTotal = 0;
    order.totalDiscounts = 0;
    order.totalSurcharges = 0;
    order.subTotalBeforeTaxes = 0;
    order.totalTaxes = 0;
    order.total = 0;

    order.detail.forEach((od) => {
      if (od.statusId == StatusEnum.ACTIVE) {
        order.subTotal += od.subTotal;
        order.totalDiscounts += od.totalDiscounts;
        order.totalSurcharges += od.totalSurcharges;
        order.subTotalBeforeTaxes += od.subTotalBeforeTaxes;
        order.totalTaxes += od.totalTaxes;
        order.total += od.total;
      }
    });
    this.cdr.detectChanges();
  }

  onChangeQuantityInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (
      order.class["makesStockValidation"] &&
      orderDetail["stockToValidate"] &&
      orderDetail.soldQuantity > orderDetail["stockToValidate"]
    ) {
      orderDetail.soldQuantity = orderDetail["stockToValidate"];
      this.snackBar.open(
        "La cantidad no debe ser mayor al disponible.",
        "Cerrar",
        { duration: 3000 }
      );
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  onChangePriceInOrderDetail(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    orderDetail["thereIsChanges"] = true;
    if (orderDetail.unitPrice < 0) {
      orderDetail.unitPrice = 0;
      this.snackBar.open("El precio no debe ser menor a cero.", "Cerrar", {
        duration: 3000,
      });
    }
    this.onChangeSubTotalInOrderDetail(order, orderDetail);
  }

  openOrderDetailUpdateConfirmation(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    if (orderDetail["thereIsChanges"])
      this.dialog
        .open(this.orderDetailUpdateConfirmationDialog, {
          data: null,
          panelClass: "form-modal",
          disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) this.onSaveOrderDetailUpdate(order, orderDetail);
        });
    else orderDetail["isEditMode"] = false;
    this.cdr.detectChanges();
  }

  onSaveOrderDetailUpdate(
    order: OrderAttributes,
    orderDetail: OrderDetailAttributes
  ): void {
    const dataToUpdate: IUpdateOrder = {
      detail: [
        {
          position: orderDetail.position,
          warehouseId: orderDetail.warehouse
            ? String(orderDetail.warehouse._id)
            : null,
          soldQuantity: orderDetail.soldQuantity,
          unitPrice: orderDetail.unitPrice,
        },
      ],
    };

    this.updateOrderService
      .updateOrder(String(order._id), dataToUpdate)
      .subscribe({
        next: (result) => {
          this.snackBar.open("Detalle actualizado con éxito.", "Cerrar", {
            duration: 3000,
          });
          orderDetail["isEditMode"] = false;
          orderDetail["thereIsChanges"] = false;
          if (result && result.data) {
            const dataTemp = this.dataSource.data.slice();
            if (
              this.selectedOrder &&
              String(this.selectedOrder._id) == String(order._id)
            ) {
              const detailTemp: OrderDetailAttributes[] =
                result.data.detail.map((d) => {
                  const detailFoundInLocal = this.selectedOrder.detail.find(
                    (od) => od.position == d.position
                  );
                  d["stock"] = detailFoundInLocal
                    ? detailFoundInLocal["stock"]
                    : [];
                  d["stockToValidate"] = detailFoundInLocal
                    ? detailFoundInLocal["stockToValidate"]
                    : undefined;
                  return d;
                });
              this.selectedOrder.detail = detailTemp;
              this.dataSourceDetail1.data = this.selectedOrder.detail;
            }
            dataTemp.forEach((order) => {
              if (String(order._id) == String(result.data._id)) {
                order.subTotal = result.data.subTotal;
                order.totalDiscounts = result.data.totalDiscounts;
                order.totalSurcharges = result.data.totalSurcharges;
                order.subTotalBeforeTaxes = result.data.subTotalBeforeTaxes;
                order.totalTaxes = result.data.totalTaxes;
                order.total = result.data.total;
                order.detail = result.data.detail;
                order.statusERP = result.data.statusERP;
              }
            });
            this.dataSource.data = dataTemp;
            this.setDeliveredAndInvoicedTables();
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el detalle.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  async getStock(order: OrderAttributes, warehouses: WarehouseAttributes[]) {
    let dataToSend = {
      materialsIds: order.detail
        .filter((od) => od.statusId == StatusEnum.ACTIVE)
        .map((d) => String(d.material._id)),
      unitMeasureIds: [],
      warehouseIds: warehouses.map((w) => String(w._id)),
    };
    const stock: MaterialStockAttributes[] = await lastValueFrom(
      this.ordersCreationService.fetchStock(dataToSend)
    ).then((res) => res.data[0].data);

    const dateToValidate = new Date();
    dateToValidate.setMonth(
      dateToValidate.getMonth() +
        (order.company["totalMonthsToGroupStockInRouting"] ?? 0)
    );
    order.detail.forEach((od) => {
      od["stock"] = stock.filter(
        (s) => String(s.materialId) == String(od.material._id)
      );
      od["stockToValidate"] = this.roundToX(
        (order.company["groupStockByDateInRouting"] == true
          ? od["stock"]
              .filter(
                (s: MaterialStockAttributes) =>
                  String(s.warehouseId) == String(od.warehouse._id) &&
                  String(s.unitOfMeasureId) ==
                    String(od.soldUnitOfMeasure._id) &&
                  s.lotExpirationDate &&
                  new Date(s.lotExpirationDate).getTime() >=
                    dateToValidate.getTime()
              )
              .reduce((acc, s) => acc + s.availableStock, 0)
          : od["stock"].find(
              (s: MaterialStockAttributes) =>
                String(s.warehouseId) == String(od.warehouse._id) &&
                String(s.unitOfMeasureId) == String(od.soldUnitOfMeasure._id)
            )?.availableStock ?? 0) / od.baseConversionFactor,
        3
      );
    });
    if (
      this.selectedOrder &&
      String(this.selectedOrder._id) == String(order._id)
    )
      this.dataSourceDetail1.data = this.selectedOrder.detail || [];
    this.cdr.detectChanges();
  }

  async getDocumentClass(order: OrderAttributes) {
    const documentClass: DocumentClassAttributes = await lastValueFrom(
      this.documentClassService.findOne(String(order.class._id))
    ).then((res) => res.data);
    if (documentClass) order.class = documentClass;
    this.cdr.detectChanges();
  }

  roundToX(value: number, decimals: number) {
    return parseFloat(value.toFixed(decimals));
  }

  openLogModal(element: OrderAttributes) {
    let dataToModal = {
      documentIdentifier: element.serial,
    };
    this.dialog.open(LogModalComponent, {
      width: "90%",
      data: dataToModal,
      disableClose: true,
    });
  }

  validateDataToSynchronize(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "SYNC");
  }

  validateDataToEdit(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "EDIT");
  }

  validateDataToAppOrRejected(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "APPROVE") ||
      validateOrdersByAction(
        [order],
        this.documentClassesList,
        "APPROVE_GENERATE_NEXT"
      ) ||
      validateOrdersByAction([order], this.documentClassesList, "REJECT")
    );
  }

  validateDataToCopy(order: OrderAttributes) {
    return validateOrdersByAction([order], this.documentClassesList, "COPY");
  }

  validateDataToDivide(order: OrderAttributes) {
    return (
      validateOrdersByAction([order], this.documentClassesList, "DIVIDE") &&
      order?.sourceTransactions.length == 0
    );
  }

  //aprobar/rechazar
  openModal(element): void {
    const dialogRef = this.dialog.open(FormApproRejectComponent, {
      width: "800px",
      data: {
        element: element,
        requeriment: {
          approve: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE"
          ),
          approve_generate: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "APPROVE_GENERATE_NEXT"
          ),
          reject: validateOrdersByAction(
            [element],
            this.documentClassesList,
            "REJECT"
          ),
        },
        type: TypeRejectEnum.VENTA_DIRECTA,
      }, //'FACTURA'
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .subscribe((result: IUserApprovalResponse | "Close" | undefined) => {
        if (result === undefined || result == "Close") {
        } else {
          if (result) {
            let sendOrder: IUpdateOrder = {
              reasonForRejectionId: result.reasonRejectionId ?? null,
              statusId: result.approve
                ? StatusEnum.ORDER_APPROVED
                : StatusEnum.INACTIVE,
            };

            this.updateAppReje(element, sendOrder);
          }
        }
      });
  }

  updateAppReje(element, result) {
    this.ordersListService.update(element._id, result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  cloneOrder(element: OrderAttributes, type: string) {
    //type: 'copy', 'divide'
    const dialogRef = this.dialog.open(SelectOrderDetailComponent, {
      data: { order: element, type: type },
      disableClose: true,
      width: "90%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.data) {
      }
    });
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  onExportButtonPressed() {
    if (!this.salesInvoiceListExport.canStartTask()) return;

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: SALES_ORDERS_LIST_TITLE,
      },
    });

    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.salesInvoiceListExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex
        );
      }
    });
  }

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  fetchSoldToName = (soldtoId: string): string => {
    const foundSoldTo = this.soldToList.find(
      (soldTo) => soldTo.id === soldtoId
    );
    if (foundSoldTo) {
      return foundSoldTo.name;
    }
    return "";
  };

  fetchShipToName = (shipToId: string): string => {
    const foundShipTo = this.shipToList.find(
      (shipTo) => shipTo.id === shipToId
    );
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return "";
  };

  getTooltip(el: OrderAttributes): string {
    const rutaCode =
      el?.subRoute?.externalKeys?.code ?? el?.subRoute?.model ?? "-";
    const rutaName = el?.subRoute?.name ?? "-";
    const user = el?.user?.user_login?.username ?? "-";

    const person = el?.responsibleBusinessPartner?.personNumber
      ? `${el.responsibleBusinessPartner.personNumber} - `
      : "";
    const bpCode = el?.responsibleBusinessPartner?.externalKeys?.code ?? "";
    const bpName = el?.responsibleBusinessPartner?.name ?? "-";

    return [
      `Ruta: ${rutaCode} | ${rutaName}`,
      `Usuario: ${user}`,
      `Responsable: ${person}${bpCode} ${bpName}`.trim(),
    ].join("\n");
  }

  handleOpenCreditNote(payment: GroupedPayment): void {
    this.dialog.open(CreditNoteDialogComponent, {
      width: "800px",
      data: payment.originalPayments,
      autoFocus: false,
    });
  }

  handleToggleInner(payment: GroupedPayment): void {}

  private loadOrderPayments(serialInvoice: string): void {
    if (!serialInvoice) {
      this.selectedOrderPayments = [];
      return;
    }
    this.isLoadingPayments = true;
    this.orderPaymentService
      .findPaymentsByInvoiceSerial(serialInvoice)
      .subscribe({
        next: (response) => {
          this.selectedOrderPayments = response?.data?.[0]?.data || [];
          this.isLoadingPayments = false;
        },
        error: (error) => {
          this.snackBar.open(
            error.error.message || "Error loading payments:",
            "Cerrar",
            { duration: 5000 }
          );
          this.selectedOrderPayments = [];
          this.isLoadingPayments = false;
        },
      });
  }
  reprintInvoice(element: OrderAttributes): void {
    if (!element._id) {
      this.snackBar.open("No se encontró el ID de la factura", "Cerrar", {
        duration: 3000,
      });
      return;
    }
    const invoiceId = element._id.toString();
    this.isReprintLoading[invoiceId] = true;
    const options: InvoicePdfOptions = {
      format: "letter",
      landscape: false,
      scale: 1,
      printBackground: true,
      marginTop: "10mm",
      marginBottom: "10mm",
    };

    this.invoiceService.downloadAndSaveInvoice(invoiceId, options).subscribe({
      next: () => {
        this.snackBar.open("Factura descargada correctamente", "Cerrar", {
          duration: 3000,
        });
      },
      error: (error) => {
        this.snackBar.open(
          error.message || "Error al imprimir la factura",
          "Cerrar",
          { duration: 5000 }
        );
      },
      complete: () => {
        this.isReprintLoading[invoiceId] = false;
      },
    });
  }

  canReprintInvoice(element: OrderAttributes): boolean {
    return this.invoiceService.canReprintInvoice(element);
  }

  hasTrip(element: OrderAttributes): boolean {
    return !!element?.trip?.id;
  }
}
